import React from 'react';
import { Collapse } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import cx from 'classnames';
import s from './s.module.less';
import { FAQ_DATA, FAQItem } from './constants';

const { Panel } = Collapse;

const FAQs: React.FC = () => {
    const [openedKey, setOpenedKey] = React.useState<string[]>([]);

    const onChange = (key: string | string[]) => {
        setOpenedKey(key as string[]);
    };

    return (
        <div className={s.wrap}>
            <div className={s.headerSection}>
                <div className={s.headerTitle}>
                    Your ultimate guide for the Klarity reviews
                </div>
                <div className={s.headerBorder} />
            </div>
            <div className={s.cards}>
                <Collapse
                    activeKey={openedKey}
                    rootClassName={s.collapse}
                    bordered={false}
                    onChange={onChange}
                >
                    {FAQ_DATA.map((item: FAQItem) => {
                        const fold = !openedKey.includes(item.key);
                        return (
                            <Panel
                                header={
                                    <div
                                        className={cx(s.question, !fold && s.active)}
                                    >
                                        <span className={s.title}>
                                            {item.question}
                                        </span>
                                        <DownOutlined className={s.icon} />
                                    </div>
                                }
                                key={item.key}
                                showArrow={false}
                            >
                                <div
                                    className={s.answer}
                                    // eslint-disable-next-line react/no-danger
                                    dangerouslySetInnerHTML={{
                                        __html: item.answer || '',
                                    }}
                                />
                            </Panel>
                        );
                    })}
                </Collapse>
            </div>
        </div>
    );
};

export default FAQs;
